import { useEffect } from 'react'

const siteName = '野村アセットマネジメント'

export function useHeadTitle(...pageNames: (string | number | undefined | null)[]) {
  useEffect(() => {
    const pageName = pageNames.filter((name) => `${name ?? ''}`.length > 0).join(' | ')
    document.title = pageName && pageName.length > 0 ? `${pageName} | ${siteName}` : siteName
  }, [pageNames])
}
